export const LIST = "EVENT_QNA_LIST";
export const OPTION_DATA = "EVENT_QNA_OPTION_DATA";
export const CREATE = "EVENT_QNA_CREATE";
export const UPDATE = "EVENT_QNA_UPDATE";
export const UPDATE_STATUS = "EVENT_QNA_UPDATE_STATUS";
export const UPDATE_ANSWER = "EVENT_QNA_UPDATE_ANSWER";
export const PAYOUT = "EVENT_QNA_PAYOUT";